import { Col, Row, Card, Button, Divider, Rate, Tag, Spin } from "antd";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  BOOKING,
  FARE,
  RATES,
  RATING,
  UPLOADS_URL,
} from "../../config/constants/api";
import { useLocation, useNavigate } from "react-router-dom";
import { extractDate, extractTime } from "../../config/helpers";
import { Get } from "../../config/api/get";
import DashbordSidebar from "../../components/DashboardSidebar";
import Slider from "react-slick";
import ChatComponent from "../../components/ChatComponent";
import socket from "../../config/socket/index";
import ReviewModal from "../../components/ReviewModal";
import MapComponent from "../../components/MapComponent";

const EditProfile = () => {
  const [avgRating, setAvgRating] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const sliderRef1 = useRef(null);
  const sliderRef2 = useRef(null);
  const location = useLocation();
  const [pricing, setPricing] = useState(null);
  const [latestFares, setLatestFares] = useState(null);
  const [latestRates, setLatestRates] = useState(null);
  const id = location.state?.id;
  const [loading, setLoading] = useState(true);
  // const details = location.state?.details;
  const [images, setImages] = useState(null);
  const [details, setDetails] = useState(null);
  const [currentStatus, setCurrentStatus] = useState("");
  const [isMapVisible, setIsMapVisible] = useState(false); // State to control visibility
  const [isArriveVisible, setIsArriveVisible] = useState(false); // State to toggle buttons
  const [message, setMessage] = useState("");
  const [driverPosition, setDriverPosition] = useState(null);
  const getPerMileRate = (serviceType) => {
    if (latestFares && details) {
      let service = latestFares.find(
        (fare) =>
          fare._id === serviceType &&
          fare.passengerCapacity === details?.passengerCapacity
      );
      return service?.fare;
    }
  };
  // const getPerMileRate = (serviceType) => {
  //   if (latestFares) {
  //     let service = latestFares.find((fare) => fare._id === serviceType);
  //     return service?.fare;
  //   }
  // };
  const updateDriverLocation = (location) => {
    setDriverPosition(location);
  };
  const getBookingDetails = async () => {
    setLoading(true);
    Get(BOOKING.getbooking + id, token)
      .then((response) => {
        if (response?.status) {
          setDetails(response?.data?.booking);
          setCurrentStatus(response?.data?.booking?.status);
          // setCarDetails(response?.data?.car);
          setImages([
            response?.data?.car?.image,
            ...response?.data?.car?.gallery,
          ]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("error", err);
      });
  };

  useEffect(() => {
    socket.on("updatedDriverLocation", (locationData) => {
      const { coordinates } = locationData;
      console.log(coordinates, "coordinates");
      if (coordinates && coordinates.length === 2) {
        updateDriverLocation({
          latitude: coordinates[1],
          longitude: coordinates[0],
        });
      }
    });
    return () => {
      socket.off("updatedDriverLocation");
    };
  }, []);

  useEffect(() => {
    if (!id) {
      navigate(-1);
    } else {
      getBookingDetails();
      getAllLatestFares();
      getAllLatestRates();
      getChauffeurRatings();
    }
  }, []);
  // const getHourlyRate = (serviceType) => {
  //   let capitalizedServiceType = serviceType.charAt(0).toUpperCase() + serviceType.slice(1).toLowerCase();
  //   if (latestRates) {
  //     let rate = latestRates.find((rate) => rate._id === capitalizedServiceType);
  //     return rate?.rate;
  //   }
  // };
  const getHourlyRate = (serviceType) => {
    // let capitalizedServiceType =
    //   serviceType.charAt(0).toUpperCase() + serviceType.slice(1).toLowerCase();
    if (latestRates && details) {
      let rate = latestRates.find(
        (rate) =>
          rate._id.serviceType === serviceType &&
          rate._id.passengerCapacity === details?.passengerCapacity
      );
      return rate?.rate;
    }
  };
  const getChauffeurRatings = async () => {
    if (details?.chauffeur?._id) {
      Get(RATING.getChauffeurRatings + details?.chauffeur?._id, token)
        .then((response) => {
          if (response?.status) {
            setAvgRating(response?.data?.averageRating);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    }
  };
  const getAllLatestFares = () => {
    Get(FARE.getAllLatestFares, token)
      .then((response) => {
        if (response?.status) {
          setLatestFares(response?.data?.latestFares);
          setPricing(response?.data?.pricing);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getAllLatestRates = () => {
    Get(RATES.getAllLatestRates, token)
      .then((response) => {
        if (response?.status) {
          setLatestRates(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  useEffect(() => {
    setNav1(sliderRef1.current);
    setNav2(sliderRef2.current);
  }, [sliderRef1?.current, sliderRef2?.current, images]);

  const sliderSettings = {
    slidesToShow: 4,
    swipeToSlide: true,
    focusOnSelect: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 768, // Small screens
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  const [showReviewModal, setShowReviewModal] = useState(false);
  const handleOkReviewModal = () => {
    setShowReviewModal(false);
    navigate(`/chauffeurBookingLogs/complete/${details?._id}`, {
      state: { details },
    });
  };

  const handleStartClick = () => {
    setIsMapVisible(true); // Show map and hide steps
    setIsArriveVisible(true); // Show Arrive button
  };

  const handleArriveClick = () => {
    console.log("Arrived!"); // Add further logic if needed
  };

  const [isChatVisible, setIsChatVisible] = useState(false); // State to control chat visibility

  const toggleChat = () => {
    setIsChatVisible(!isChatVisible); // Toggle chat visibility
  };
  const getTotalFare = () => {
    let total = 0;
    if (details?.initialMileage) {
      total +=
        details?.initialMileage.toFixed(2) *
        getPerMileRate(
          details?.serviceType.charAt(0).toUpperCase() +
            details?.serviceType.slice(1).toLowerCase()
        );
    }
    if (!(details?.type === "Subscription")) {
      total += details?.duration * getHourlyRate(details?.serviceType);
    }
    total += details?.rushHourFee;
    return total;
  };
  useEffect(() => {
    socket.on("statusChanged", (data) => {
      const { status } = data;
      setCurrentStatus(status);
      return () => {
        socket.off("statusChanged");
      };
    });
  }, []);
  useEffect(() => {
    if (currentStatus === "ONGOING") {
      setMessage("Your Booking has Started");
    } else if (currentStatus === "ARRIVED") {
      setMessage("Your driver has arrived");
    } else if (currentStatus === "COMPLETED") {
      setMessage("Your Booking has ended");
      setShowReviewModal(true);
    }
  }, [currentStatus]);

  // const calculateRushHourFee = (serviceType) => {
  //   if (latestRates && details) {
  //     let rate = latestRates.find((rate) => rate._id === serviceType);
  //     let rushHourFee = rate?.rate * rate?.rushHourMultiple - rate?.rate;
  //     return rushHourFee;
  //   }
  // };
  const calculateRushHourFee = (serviceType) => {
    if (latestRates && details) {
      let rate = latestRates.find(
        (rate) =>
          rate._id.serviceType === serviceType &&
          parseInt(rate._id.passengerCapacity) === details?.passengerCapacity
      );
      let rushHourFee = rate?.rate * rate?.rushHourMultiple - rate?.rate;
      return rushHourFee;
    }
  };

  return (
    <div className="shop-page bg-white py-6">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        {!loading ? (
          <Col xs={23} md={21}>
            <div className="shop-page-main">
              <Row gutter={[16, 16]}>
                <Col xs={24} md={24} lg={24} xl={24}>
                  <div className="my-account-profile">
                    <section className="side-menu-parent">
                      <DashbordSidebar />
                      <div className="about-us-section">
                        <div className="profile-information-wrapper">
                          <FaArrowLeftLong
                            className="arrow cursor-pointer"
                            onClick={() => navigate(-1)}
                          />
                          <h3 className="text-5xl max-desktop:text-4xl font-goldman text-center py-4">
                            Chauffeur Booking Details
                          </h3>
                        </div>
                        <div className="bg-parent relative">
                          <Row justify="center">
                            <Col xs={24} md={24} xl={24}>
                              <Card>
                                <div className="boxDetails">
                                  <Row>
                                    <Col lg={12}>
                                      <div className="pet-name-pic">
                                        {!(
                                          details?.status === "PAID" ||
                                          details?.status === "PENDING"
                                        ) && (
                                          <div>
                                            <Button
                                              onClick={toggleChat}
                                              className="web-btn"
                                            >
                                              message
                                            </Button>
                                          </div>
                                        )}
                                      </div>
                                      {(currentStatus === "ONGOING" ||
                                        currentStatus === "ARRIVED" ||
                                        currentStatus === "COMPLETED") && (
                                        <Tag className="my-2" color="success">
                                          {message}
                                        </Tag>
                                      )}
                                    </Col>
                                    <Col lg={12}>
                                      <div className="flex justify-end items-center">
                                        {!(
                                          details?.status === "PAID" ||
                                          details?.status === "PENDING"
                                        ) &&
                                          avgRating && (
                                            <div className="view-rating">
                                              <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1 p-2">
                                                Overall Rating
                                              </h5>
                                              <span>
                                                <Rate
                                                  disabled
                                                  defaultValue={avgRating}
                                                />
                                              </span>
                                            </div>
                                          )}
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row
                                    justify="start"
                                    className="my-4"
                                    gutter={[16, 16]}
                                  >
                                    <Col xs={24} md={24} lg={20} xxl={12}>
                                      <div className="bg-[#EBEBEB] rounded-lg flex max-sm:flex-col items-center justify-between xl:p-3 p-3">
                                        <div className="flex flex-col items-start justify-center max-sm:order-1">
                                          <h5 className="font-euclid text-sm max-xl:text-xs text-black font-bold mb-1">
                                            {extractDate(details?.date)} at{" "}
                                            {extractTime(details?.time)} (PDT)
                                          </h5>
                                          <p className="font-euclid text-sm max-xl:text-xs text-gray-500 font-normal mb-2 sm:mr-4">
                                            {details?.pickupLocation?.address}{" "}
                                            To{" "}
                                            {details?.dropoffLocation?.address
                                              ? details?.dropoffLocation
                                                  ?.address
                                              : "-"}
                                          </p>
                                          <p className="font-euclid text-sm max-xl:text-xs text-gray-500 font-normal mb-2 sm:mr-4">
                                            Total mileage:{" "}
                                            {details?.finalMileage
                                              ? details?.finalMileage.toFixed(2)
                                              : details?.initialMileage.toFixed(
                                                  2
                                                )}{" "}
                                            miles
                                          </p>
                                          {details?.type !== "Subscription" &&
                                            !details?.dropoffLocation && (
                                              <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                                                $
                                                {getHourlyRate(
                                                  details?.serviceType
                                                ) * details?.duration}
                                                /{details?.duration}hrs
                                              </h5>
                                            )}
                                        </div>
                                        {/* <img
                                        src={ImageUrl("limo-bg.png")}
                                        alt="limo"
                                        className="max-sm:order-0"
                                      /> */}
                                      </div>
                                    </Col>
                                    {details?.chauffeur && (
                                      <Col xs={24} md={24} lg={20} xxl={12}>
                                        <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:p-3 p-3 ">
                                          <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                                            Chauffeur Details
                                          </h5>
                                          <div className="flex justify-center  my-2 resp-flex-none">
                                            <div className="flex flex-col items-start lg:mr-36 mr-12">
                                              <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                Name
                                              </h5>
                                              <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-2">
                                                {details?.chauffeur?.firstName}{" "}
                                                {details?.chauffeur?.lastName}
                                              </p>
                                              {/* <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                              Contact
                                            </h5>
                                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-3">
                                              {details?.chauffeur?.phone}
                                            </p> */}
                                            </div>
                                            <img
                                              src={
                                                UPLOADS_URL +
                                                details?.chauffeur?.image
                                              }
                                              alt="chauffeur"
                                              className="max-sm:order-0"
                                              style={{
                                                width: "100px",
                                                height: "100px",
                                                borderRadius: "100%",
                                                objectFit: "cover",
                                                objectPosition: "center",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                    )}
                                  </Row>

                                  <Row className="my-3 justify-normal">
                                    {details?.notes && (
                                      <Col xs={22} md={24} lg={20} xxl={12}>
                                        <div className="">
                                          <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1 ">
                                            Additional Notes
                                          </h5>
                                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                            {details?.notes}
                                          </p>
                                        </div>
                                      </Col>
                                    )}
                                    <Col xs={22} md={24} lg={20} xxl={12}>
                                      <div className="border border-gray-300 py-4 px-4 pay-slip">
                                        <h4 className="font-tavi text-[20px] text-black mt-2">
                                          {details?.dropoffLocation
                                            ? "Distance Service in Manhattan"
                                            : "Hourly Service in Manhattan"}
                                        </h4>
                                        <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                          <span className="text-[#000] font-black">
                                            Vehicle Type:
                                          </span>{" "}
                                          {details?.serviceType} Luxury
                                        </p>
                                        {!details?.dropoffLocation && (
                                          <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                            <span className="text-[#000] font-black">
                                              {" "}
                                              Booking Duration:
                                            </span>{" "}
                                            {details?.duration} hours
                                          </p>
                                        )}
                                        <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                          <span className="text-[#000] font-black">
                                            {" "}
                                            Mileage:
                                          </span>{" "}
                                          {details?.finalMileage
                                            ? details?.finalMileage.toFixed(2)
                                            : details?.initialMileage.toFixed(
                                                2
                                              )}{" "}
                                          miles
                                        </p>

                                        <Divider className="my-2" />
                                        <h4 className="font-tavi text-[20px] text-black mt-2">
                                          Pricing Breakdown:
                                        </h4>
                                        {details?.type !== "Subscription" &&
                                          !details?.dropoffLocation && (
                                            <>
                                              <span className="text-[#000] font-semibold pt-2">
                                                Hourly Rate: $
                                                {getHourlyRate(
                                                  details?.serviceType
                                                )}{" "}
                                                per hour
                                              </span>
                                              <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                                Total for {details?.duration}{" "}
                                                hours: {details?.duration} hours
                                                × $
                                                {getHourlyRate(
                                                  details?.serviceType
                                                )}
                                                /hour = $
                                                {getHourlyRate(
                                                  details?.serviceType
                                                ) * details?.duration}
                                                /{details?.duration}hrs
                                              </p>
                                            </>
                                          )}
                                        
                                        {details?.initialMileage ? <>
                                        <span className="text-[#000] font-semibold pt-2">
                                          Mileage Fee:
                                        </span>
                                        <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                          {details?.serviceType} Luxury: $
                                          {getPerMileRate(
                                            details?.serviceType
                                              .charAt(0)
                                              .toUpperCase() +
                                              details?.serviceType
                                                .slice(1)
                                                .toLowerCase()
                                          )}{" "}
                                          per mile
                                        </p>
                                        <p className="font-euclid text-sm max-sm:text-xs text-[#666]  font-bold transition-colors">
                                          Total for{" "}
                                          {details?.finalMileage
                                            ? details?.finalMileage.toFixed(2)
                                            : details?.initialMileage.toFixed(
                                                2
                                              )}{" "}
                                          miles :{" "}
                                          {details?.finalMileage
                                            ? details?.finalMileage.toFixed(2)
                                            : details?.initialMileage.toFixed(
                                                2
                                              )}{" "}
                                          miles × ${" "}
                                          {getPerMileRate(
                                            details?.serviceType
                                              .charAt(0)
                                              .toUpperCase() +
                                              details?.serviceType
                                                .slice(1)
                                                .toLowerCase()
                                          )}
                                          /mile = $
                                          {(details?.finalMileage
                                            ? details?.finalMileage.toFixed(2)
                                            : details?.initialMileage.toFixed(
                                                2
                                              ) *
                                              getPerMileRate(
                                                details?.serviceType
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  details?.serviceType
                                                    .slice(1)
                                                    .toLowerCase()
                                              )
                                          ).toFixed(2)}
                                        </p>
                                        </> : <></>}
                                        {details?.rushHours &&
                                        details?.duration ? (
                                          <p className="text-[#000] font-semibold pt-2">
                                            Rush Hour Fee : $
                                            {calculateRushHourFee(
                                              details?.serviceType
                                            )}{" "}
                                            {/* {calculateRushHourFee(
                                              details?.serviceType
                                                .charAt(0)
                                                .toUpperCase() +
                                                details?.serviceType
                                                  .slice(1)
                                                  .toLowerCase()
                                            )}{" "} */}
                                            per hour <br />
                                            <span className="font-euclid text-sm max-sm:text-xs text-[#666] font-bold transition-colors">
                                              {" "}
                                              Total for {
                                                details?.rushHours?.toFixed(2)
                                              }{" "}
                                              hours : {details?.rushHours?.toFixed(2)} hours
                                              x $
                                              {calculateRushHourFee(
                                                details?.serviceType
                                                 )}{" "}
                                              {/* {calculateRushHourFee(
                                                details?.serviceType
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  details?.serviceType
                                                    .slice(1)
                                                    .toLowerCase()
                                              )}{" "} */}
                                              = ${details?.rushHourFee?.toFixed(2)}
                                            </span>
                                          </p>
                                        ) : (
                                          <></>
                                        )}
                                        <Divider className="my-2" />
                                        <span className="text-[#000] font-bold pt-2 to-pay">
                                          Paid Amount: $
                                          {getTotalFare().toFixed(2)}
                                        </span>
                                      </div>
                                    </Col>
                                  </Row>

                                  {!(
                                    currentStatus === "ONGOING" ||
                                    currentStatus === "ARRIVED"
                                  ) ? (
                                    <Row justify="center">
                                      {details?.chauffeur && (
                                        <Col md={24} xs={24}>
                                          <div
                                            className="bg-white rounded-lg  mb-12"
                                            // style={{
                                            //   boxShadow:
                                            //     "1px 1px 1px 1px rgba(0, 0, 0, 0.05)",
                                            // }}
                                          >
                                            <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black py-4">
                                              Car Details
                                            </h3>
                                            <Row
                                              justify="left"
                                              gutter={[32, 32]}
                                            >
                                              <Col
                                                xxl={10}
                                                xl={10}
                                                xs={24}
                                                className="customSlider sm:px-4 self-center innermultiple-slider"
                                              >
                                                {Array.isArray(images) &&
                                                  images.length > 0 && (
                                                    <div>
                                                      <Slider
                                                        asNavFor={nav2}
                                                        ref={sliderRef1}
                                                        arrows={false}
                                                        adaptiveHeight={true} // Ensure slider adapts to image height
                                                        autoplay={false} // Disable autoplay to avoid constant re-rendering
                                                      >
                                                        {images.map(
                                                          (img, index) => (
                                                            <div
                                                              key={index}
                                                              className="w-full"
                                                            >
                                                              <img
                                                                src={
                                                                  UPLOADS_URL +
                                                                  img
                                                                }
                                                                alt={`Slide ${index}`}
                                                                style={{
                                                                  width: "100%",
                                                                  maxHeight:
                                                                    "250px",
                                                                  objectFit:
                                                                    "cover",
                                                                  objectPosition:
                                                                    "center",
                                                                  height:
                                                                    "250px",
                                                                }}
                                                              />
                                                            </div>
                                                          )
                                                        )}
                                                      </Slider>
                                                      <Slider
                                                        asNavFor={nav1}
                                                        ref={sliderRef2}
                                                        {...sliderSettings}
                                                      >
                                                        {images.map(
                                                          (img, index) => (
                                                            <div key={index}>
                                                              <img
                                                                src={
                                                                  UPLOADS_URL +
                                                                  img
                                                                }
                                                                alt={`Slide ${index}`}
                                                                style={{
                                                                  width: "100%",
                                                                  height:
                                                                    "90px",
                                                                  objectFit:
                                                                    "cover",
                                                                  objectPosition:
                                                                    "center",
                                                                  maxWidth:
                                                                    "250px",
                                                                }}
                                                              />
                                                            </div>
                                                          )
                                                        )}
                                                      </Slider>
                                                    </div>
                                                  )}
                                              </Col>
                                              <Col xxl={12} xl={14} xs={24}>
                                                <div className="flex justify-center my-4 w-full">
                                                  <div className="flex flex-col items-start w-full">
                                                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                      Car Brand
                                                    </h5>
                                                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                      {details?.car?.brand}
                                                    </p>
                                                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                      Car Model
                                                    </h5>
                                                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                      {details?.car?.model}
                                                    </p>

                                                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                      Service Type
                                                    </h5>
                                                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                      {
                                                        details?.car
                                                          ?.serviceType
                                                      }{" "}
                                                      Luxury
                                                    </p>
                                                  </div>
                                                  <div className="flex flex-col items-start w-full">
                                                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                      Car Name
                                                    </h5>
                                                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                      {details?.car?.name}
                                                    </p>
                                                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                      Car Number
                                                    </h5>
                                                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                      {details?.car?.carNumber}
                                                    </p>
                                                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                      Passenger Capacity
                                                    </h5>
                                                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                      {
                                                        details?.car
                                                          ?.passengerCapacity
                                                      }
                                                    </p>
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Col>
                                      )}
                                    </Row>
                                  ) : (
                                    <>
                                      {driverPosition && (
                                        <MapComponent
                                          booking={details}
                                          status={currentStatus}
                                          driverPosition={driverPosition}
                                        />
                                      )}
                                    </>
                                  )}
                                </div>
                              </Card>
                            </Col>
                          </Row>
                          {isChatVisible && (
                            <ChatComponent
                              setIsChatVisible={setIsChatVisible}
                              isChatVisible={isChatVisible}
                              data={details}
                            />
                          )}
                        </div>
                      </div>
                    </section>
                    <ReviewModal
                      open={showReviewModal}
                      handleOk={handleOkReviewModal}
                      handleCancel={handleOkReviewModal}
                      firstName={details?.chauffeur?.firstName}
                      lastName={details?.chauffeur?.lastName}
                      driver={details?.chauffeur?._id}
                      // text="How was Your Experience"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        ) : (
          <Col style={{ margin: "200px 0px" }}>
            <Spin />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default EditProfile;
